import { SharedTheme } from '../models/theme';

export const sharedDefaultTheme: SharedTheme = {
  confirmationModal: {
    icon: {
      color: '#ff4d4f',
    },
  },
};
